import { anyOf } from '@/router/routeMeta.js';
import { RoleGroups, Roles } from '@/router/roles';

export const clientRoutes = [
	{
		path: 'client',
		name: 'Client Dashboard',
		meta: anyOf(RoleGroups.CLUB),
		component: () => import('@/finance/views/client/ClientBilling.vue'),
		props: { summary: true }
	},
	{
		path: 'client/invoices',
		name: 'Client Invoices',
		meta: { ...Roles.CLUB_ADMINISTRATOR, clientPortalSection: 'invoices' },
		component: () => import('@/finance/views/client/ClientBilling.vue')
	},
	{
		path: 'client/games',
		name: 'Client Games',
		meta: { ...anyOf(RoleGroups.CLUB), clientPortalSection: 'games' },
		component: () => import('@/finance/views/client/ClientGames.vue')
	}
];
